import { Component, Input, Output, EventEmitter,inject, TemplateRef, OnInit, SimpleChanges, OnChanges  } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';


@Component({
    selector: 'app-custom-popup',
    templateUrl: './custom-popup.component.html',
    styleUrls: ['./custom-popup.component.css'],
    standalone: false
})
export class CustomPopupComponent implements OnChanges {

 @Input() img?: string;
 @Input() title?: string;
 @Input() subTitle?:string;
 @Input() showCloseButton?: boolean;

 @Input() description?: string;
 @Input() isHTML?: boolean;
@Input() isForm ?: boolean;
 @Input() contentTemplate?: TemplateRef<any>;
 @Input() contentContext?: any;
 @Input() buttons: { title: string, actionId: string, isActive:boolean, styleClass?: string }[] = [];
 @Output() buttonClicked = new EventEmitter<string>();

 @Input() icon: string = ''; // Icon for the popup
 // @Input() fields: { name: string; label: string; type: string; validation?: any }[] = []; // Dynamic fields
 @Output() actionEvent = new EventEmitter<{ actionId: string; formData?: any }>(); // Emit button actions

 form: FormGroup = new FormGroup({});
 isFormReady: boolean = false;
 private _fields: { name: string;value:string; defaultValue:string; placeholder: string; label: string; type: string; validation?: any,isrequired?:boolean,options?: string[];  }[] = [];

 @Input()
 set fields(value: { name: string;value:string; defaultValue:string; placeholder: string; label: string; type: string; validation?: any,isrequired?:boolean,options?: string[];  }[]) {
   this._fields = value || [];
   // rebuild the form every time fields change
   this.initializeForm();
 }
 
 get fields() {
   return this._fields;
 }

 constructor(public bsModalRef: BsModalRef, private fb: FormBuilder) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['fields'] && !changes['fields'].firstChange) {
      this.initializeForm(); // Reinitialize the form if fields change
    }
  }

  initializeForm(): void {
    const formControls: { [key: string]: any[] } = {};
    this.fields.forEach(field => {
      // formControls[field.name] = ['', field.validation || []];
      formControls[field.name] = [field.value || field.defaultValue || '', field.validation || []];
    });
    this.form = this.fb.group(formControls);
    this.isFormReady = true;
  }

  onButtonClick(actionId: string) {
    this.buttonClicked.emit(actionId);
    this.actionEvent.emit({ actionId });
    this.bsModalRef.hide();
  }

  handleAction(actionId: string) {
    if (actionId === 'confirm' && this.form.invalid) {
      this.form.markAllAsTouched(); // Mark all fields as touched to show validation errors
      return;
    }
    const formData = this.isForm ? { ...this.form.value } : null;

    if (formData && formData.volume) {
      formData.volume = Number(formData.volume);
    }
    this.actionEvent.emit({ actionId, formData });
  }
}